export const UPDATE_EDOK_DOCUMENTATIONS_REQUEST = 'UPDATE_EDOK_DOCUMENTATIONS_REQUEST';

export const updateEdokDocumentationsRequest = ( year, updateData ) => ({
    type: UPDATE_EDOK_DOCUMENTATIONS_REQUEST,
    payload: {
        year,
        updateData
    }
});
